const META_CONTENT_ID_MAX_LENGTH = 100
const CONTENT_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._:-]*$/

export const normalizeCatalogContentId = (
  value: unknown
): string | undefined => {
  if (value === null || typeof value === "undefined") return undefined
  const candidate = String(value).trim()
  if (
    !candidate ||
    candidate === "[object Object]" ||
    candidate.length > META_CONTENT_ID_MAX_LENGTH ||
    !CONTENT_ID_PATTERN.test(candidate)
  ) {
    return undefined
  }
  return candidate
}

export const resolveCatalogContentId = ({
  productId,
  variant,
}: {
  productId: unknown
  variant?: {
    catalogContentId?: unknown
    _id?: unknown
    id?: unknown
    variantId?: unknown
  } | null
}): string | undefined => {
  for (const candidate of [
    variant?.catalogContentId,
    variant?._id,
    variant?.id,
    variant?.variantId,
    productId,
  ]) {
    const normalized = normalizeCatalogContentId(candidate)
    if (normalized) return normalized
  }
  return undefined
}

export const resolveLineCatalogContentId = (line: {
  catalogContentId?: unknown
  variantId?: unknown
  productId?: unknown
  productSlug?: unknown
}): string | undefined => {
  for (const candidate of [
    line.catalogContentId,
    line.variantId,
    line.productId,
    line.productSlug,
  ]) {
    const normalized = normalizeCatalogContentId(candidate)
    if (normalized) return normalized
  }
  return undefined
}
